import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"

import { RootState } from "./redux-store"

export interface NavigationSliceState {
  previousPage: string | null
}

export const navigationSliceInitialState: NavigationSliceState = {
  previousPage: null,
}

const navigationSlice = createSlice({
  name: "navigation",
  initialState: navigationSliceInitialState,
  reducers: {
    setPreviousPage(state, action: PayloadAction<string | null>) {
      state.previousPage = action.payload
    },
  },
})

const selectSliceState = (state: RootState) => state.navigationSlice

export const selectPreviousPage = createSelector(
  [selectSliceState],
  (state) => state.previousPage
)

export const { setPreviousPage } = navigationSlice.actions
export default navigationSlice.reducer
